var h = Object.defineProperty;
var c = (o, t, s) => t in o ? h(o, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : o[t] = s;
var a = (o, t, s) => c(o, typeof t != "symbol" ? t + "" : t, s);
import { v4 as r } from "uuid";
const i = class i {
  /**
   * Prevents external instantiation.
   */
  constructor() {
    /**
     * Stores the currently active modals.
     */
    a(this, "modals", []);
    /**
     * Stores listeners to notify about modal changes.
     */
    a(this, "listeners", []);
    this.removeModal = this.removeModal.bind(this);
  }
  /**
   * Retrieves the singleton instance of the `ModalManager`.
   * @returns The singleton instance of `ModalManager`.
   */
  static getInstance() {
    return i.instance || (i.instance = new i()), i.instance;
  }
  _getBackdropElevation(t) {
    const s = [100, 200];
    return s[Math.min(t, s.length - 1)];
  }
  /**
   * Adds a new modal to the manager.
   * @param modal - The modal to add.
   */
  addModal(t) {
    const s = t.id || r(), e = this.modals.filter((d) => d.open).length, n = {
      ...t,
      id: s,
      open: !0,
      backdropElevation: this._getBackdropElevation(e)
    };
    this.modals.push(n), this.notifyListeners();
  }
  /**
   * Adds a new modal to the manager and remove all others.
   * @param modal - The modal to add.
   */
  replaceModal(t) {
    this.modals = [
      {
        ...t,
        id: t.id || r(),
        open: !0,
        backdropElevation: this._getBackdropElevation(0)
      }
    ], this.notifyListeners();
  }
  /**
   * Update existing modal data.
   * @param id - The ID of the modal to remove.
   * @param data - The data to update in the modal.
   */
  updateModal(t, s) {
    const e = this.modals.findIndex((n) => n.id === t);
    if (e === -1) {
      console.warn(`Modal ${t} was not found`);
      return;
    }
    this.modals[e] = { ...this.modals[e], ...s }, this.notifyListeners();
  }
  /**
   * Removes a modal by its ID.
   * @param id - The ID of the modal to remove.
   */
  removeModal(t) {
    const s = this.modals.find((e) => e.id === t);
    s != null && s.triggerElementRef && requestAnimationFrame(() => {
      var e, n;
      (n = (e = s == null ? void 0 : s.triggerElementRef) == null ? void 0 : e.current) == null || n.focus();
    }), this.modals = this.modals.filter((e) => e.id !== t), this.notifyListeners();
  }
  /**
   * Removes all modals.
   */
  removeAllModals() {
    this.modals = [], this.notifyListeners();
  }
  /**
   * Notifies all subscribed listeners about the current state of modals.
   */
  notifyListeners() {
    this.listeners.forEach((t) => t([...this.modals]));
  }
  /**
   * Subscribes a listener to modal changes.
   * @param listener - The listener to subscribe.
   */
  subscribe(t) {
    this.listeners.push(t);
  }
  /**
   * Unsubscribes a listener from modal changes.
   * @param listener - The listener to unsubscribe.
   */
  unsubscribe(t) {
    this.listeners = this.listeners.filter((s) => s !== t);
  }
};
a(i, "instance");
let l = i;
export {
  l as ModalManager
};
//# sourceMappingURL=index.es97.js.map
